import type { IbeFilterConfiguration } from '@/types/SearchDefaults';

declare const ibeFilterConfiguration: IbeFilterConfiguration | undefined;

/**
 * Safe accessor for the global `ibeFilterConfiguration` variable injected by
 * the backend (Pimcore). Returns `null` when the variable is undefined or not
 * an object, so callers can branch on a single truthiness check.
 *
 * Mirrors the pattern of `loadIbeSearchDefaults()`.
 */
export function loadIbeFilterConfiguration(): IbeFilterConfiguration | null {
  if (typeof ibeFilterConfiguration === 'undefined') {
    return null;
  }

  const global = ibeFilterConfiguration;

  if (typeof global === 'object' && global !== null) {
    return global;
  }

  return null;
}
